import { TableColumnData } from '../../assets/table-column-data';

/**
 * The columns for the relations list view.
 */
export const relationsListViewColumns = {
  TABLE_DEFAULT_COLUMNS: [...TableColumnData.TABLE_DEFAULT_COLUMNS],
  ADD_COLUMNS: [...TableColumnData.ADD_COLUMNS],
};
